<script>

</script>

<div class="container mx-2">
  <h3>INFORMACION GENERAL</h3>
<h5>PRECIOS:</h5>
<p>
El precio publicado es el precio de lista abonando con tarjeta de credito (lo hacemos mediante mercado
pago), en caso de querer abonar en efectivo (solo si retiras en showroom) o por tranferencia, se aplica un
20% de descuento que se ve reflejado en el importe una vez q elijas la modalidad de pago
</p>
<h5>ENVIOS:</h5>
<p>
Los envios los realizamos por e commerce de CORREO ARGENTINO a domicilio (si queres que sea a
sucursal avisanos) Para chequear el costo solo debes completar el formulario con tu domicilio
Al ser despachado te enviamos un numero de guia para que puedas hacer el seguimiento y saber donde
esta tu paquete</p>
<p>
Cuanto tarda? En general entre 24 y 72 hs habiles
</p>
<h5>TAKE AWAY</h5>
<p>
Podes hacer tu pedido y retirarlo por nuestro showroom, solo tenemos que coordinar via whatsapp fecha y
rango horario
</p>
<h5>TALLES Y CAMBIOS</h5>
<p>
Todas nuestras prendas tienen las medidas, para que puedas calcular tu talle, de todas formas, si no te
gusta o no te va, podes cambiarlo, tenes hasta 15 dias luego de realizada tu compra, la prenda debe estar
en excelentes condiciones y con sus etiquetas colocadas tal cual se envio. (los envio siempre corren por
cuenta del comprador)
</p>
<h5>CALCULAR EL TALLE:</h5>
<p>
para calcular el talle de un jean tenes que tomar uno que te quede bien, ponerlo sobre una superficie plana
y tomar 3 medidas:
</p>
<ul>
 <li>la cintura de lado a lado</li>
 <li>la cadera de costura a costura (se toma a la altura donde termina la bragueta del jean)</li>
 <li>el tiro, desde el boton hasta la costura de la entrepierna</li>
</ul>
<p>
si aun tenes dudas, en nuestras historias destacadas de Instagram, tenes un ejemplo de como hacerlo
</p>
<br>
<h4>COMO COMPRAR POR MAYOR?</h4>
<ul>
 <li>Solicita toda la informacion y clave mayorista x whatsapp 1130503438</li>
 <li>Luego ingresa en MAYORISTA con TU e mail y a continuacion la clave que te pasamos</li>
 <li>Ya estas listo para iniciar tu compra!!!! Agrega en tu carrito lo que quieras comprar, una vez que
terminaste tu compra, llena el formulario con tu informacion, es importante que definas la forma de pago
(deposito o tranferencia para envios, efectivo si retiras por el showroom) y luego finalices tu compra.
Recomendamos que una vez finalizada tu compra nos avises por whatsapp</li>
 <li>Ahora vamos a proceder a armar tu pedido, te confirmaremos si todo lo que pediste esta en stock para
luego pasarte el total y los datos para el pago</li>
 <li>los envios se realizan dentro de las 24 hs habiles siguientes a acreditado el pago</li>
</ul>
<br>
<br>
</div>
